import { HEADER_APP_IDENTIFIER } from "../../consts/HEADER_APP_IDENTIFIER";
import { headerInterceptorFactory } from "./headerInterceptor";
export var appIdentifierInterceptorFactory = function(appIdentifier) {
    return headerInterceptorFactory({
        header: HEADER_APP_IDENTIFIER,
        value: appIdentifier
    });
};
